<template>
  <span>
    <slot name="button" v-bind="{onclick: toggle}">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal
        @show="resetModal"
        @hidden="resetModal"
        ref="modal-container"
        v-model="modalShow"
        size="lg"
        :title="title"
        :static="true"
        :lazy="true"
        hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="Display name" label-for="displayName-input">
          <b-form-input id="displayName-input"
                        v-model="formValues.displayName"
                        v-validate="{ required: true, min: 3 }"
                        :state="validateState('displayName')"
                        aria-describedby="displayName-live-feedback"
                        data-vv-name="displayName"
                        data-vv-as="Display name"
                        autocomplete="off"
          />
          <b-form-invalid-feedback id="displayName-live-feedback">{{ veeErrors.first('displayName') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Business name" label-for="businessName-input">
          <b-form-input id="businessName-input"
                        v-model="formValues.businessName"
                        v-validate="{ min: 3, minTrimmedLength: [3] }"
                        :state="validateState('businessName')"
                        aria-describedby="businessName-live-feedback"
                        data-vv-name="businessName"
                        data-vv-as="Business name"
                        autocomplete="off"
          />
          <b-form-invalid-feedback id="businessName-live-feedback">{{ veeErrors.first('businessName') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Contact person" label-for="contactPerson-input">
          <b-form-input id="contactPerson-input"
                        v-model="formValues.contactPerson"
                        v-validate="{ min: 3, minTrimmedLength: [3] }"
                        :state="validateState('contactPerson')"
                        aria-describedby="contactPerson-live-feedback"
                        data-vv-name="contactPerson"
                        data-vv-as="Contact person"
                        autocomplete="off"
          />
          <b-form-invalid-feedback id="contactPerson-live-feedback">{{ veeErrors.first('contactPerson') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Contact email" label-for="contactEmail-input">
          <b-form-input id="contactEmail-input"
                        v-model="formValues.contactEmail"
                        v-validate="{ email: true }"
                        :state="validateState('contactEmail')"
                        aria-describedby="contactEmail-live-feedback"
                        data-vv-name="contactEmail"
                        data-vv-as="Contact email"
                        autocomplete="off"
          />
          <b-form-invalid-feedback id="contactEmail-live-feedback">{{ veeErrors.first('contactEmail') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Address" label-for="address-input">
          <b-form-input id="address-input"
                        v-model="formValues.address"
                        v-validate="{ min: 3, minTrimmedLength: [3] }"
                        :state="validateState('address')"
                        aria-describedby="address-live-feedback"
                        data-vv-name="address"
                        data-vv-as="Address"
                        autocomplete="off"
          />
          <b-form-invalid-feedback id="address-live-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Notes" label-for="notes-input">
          <b-form-input id="notes-input"
                        v-model="formValues.notes"
                        v-validate="{ min: 3, minTrimmedLength: [3] }"
                        :state="validateState('notes')"
                        aria-describedby="notes-live-feedback"
                        data-vv-name="notes"
                        data-vv-as="Notes"
                        autocomplete="off"
          />
          <b-form-invalid-feedback id="notes-live-feedback">{{ veeErrors.first('notes') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Partners" label-for="partners-input">
          <b-form-group>
            <treeselect
                v-model="formValues.partners"
                :multiple="true"
                value-consists-of="LEAF_PRIORITY"
                :options="this.$store.getters['partnerGroups/list']"
                :disabled="false"
                search-nested
            />
          </b-form-group>
        </b-form-group>

      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import {getRouteIcon, ROUTE_PARTNERS} from "../../utils/routerIcons";
import Multiselect from 'vue-multiselect';
import Treeselect from '@riophae/vue-treeselect';
import Vue from "vue";

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
    }
  },
  components: {
    Multiselect,
    Treeselect,
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    handleSubmit() {
      for (let key of Object.keys(this.formValues)) {
        if (typeof this.formValues[key] === 'string') {
          this.formValues[key] = this.formValues[key].trim();
        }
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this
            .$http({
              url: this.create ? '/api/v1/partners' : '/api/v1/partners/' + this.formValues.id,
              data: {
                ...this.formValues,
              },
              method: this.create ? 'POST' : 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(() => {
              setTimeout(() => {
                this.$emit('finish');
              }, 500);

              this.hideModal();
              this.$toastr.i('Success');
            })
            .catch((err) => {
              this.$toastr.e(JSON.stringify(err.response.data.message));

              throw err;
            });
      });
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    getInitialValues() {
      return {
        id: null,
        displayName: '',
        businessName: '',
        contactPerson: '',
        contactEmail: '',
        address: '',
        notes: '',
        partners: [],
      };
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
  },
  computed: {
    routeIcon: () => getRouteIcon(ROUTE_PARTNERS),
  },
  async beforeMount() {
    await this.$store.dispatch('operatorsModule/loadList');
    await this.$store.dispatch('partnerGroups/loadList');
    await this.$store.dispatch('sourcesModule/loadList');
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
